import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import DocumentTitle from '../Components/DocumentTitle';
import DocumentMeta from '../Components/DocumentMeta';
import {escapeHtml} from 'utils/string';

import Main from './Main';
import decorate from 'spa/lib/decorate';
import withI18n from 'spa/Components/Context/withI18n';

const NotFoundPage = decorate([withI18n], (props, {i18n}) => (
  <div className="container">
    <DocumentTitle title={i18n._x('404: Page Not Found', '<title>')} />
    <DocumentMeta
      meta={{name: {robots: 'noindex'}}}
      hrefLangs={[]}
    />
    <h1 style={{marginTop: 30}}>{i18n._x('404: The page you requested couldn\'t be found', '404 page title')}</h1>

    <p
      className="lead"
      dangerouslySetInnerHTML={{
        __html: i18n._x('we\'re sorry to say that the page at <b>%(path)s</b> doesn\'t exist', '404 page content', {path: escapeHtml(props.location.pathname)}),
      }}
    />

    <p>{i18n._x('maybe you\'d like to do one of the following?', '404 page content')}</p>

    <ul>
      <li><Link to="/">{i18n._x('go to the home page', '404 page content')}</Link></li>
      <li><Link to="/booking">{i18n._x('make a new booking', '404 page content')}</Link></li>
    </ul>
  </div>
));
NotFoundPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./spa/Pages/NotFound.jsx